import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { banners } from "@/mocks/games";

export default function HomeHero() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % banners.length);
    }, 5200);
    return () => window.clearInterval(timer);
  }, []);

  const goPrev = () => setIndex((prev) => (prev - 1 + banners.length) % banners.length);
  const goNext = () => setIndex((prev) => (prev + 1) % banners.length);

  return (
    <section className="relative h-[440px] w-full overflow-hidden bg-foreground-950 md:h-[560px]" aria-label="精选推荐轮播">
      {banners.map((banner, bannerIndex) => (
        <div
          key={banner.gameId}
          className={`absolute inset-0 transition-opacity duration-700 ${
            bannerIndex === index ? "opacity-100" : "pointer-events-none opacity-0"
          }`}
        >
          <div className="absolute inset-0 bg-gradient-to-br from-primary-900 via-foreground-950 to-accent-900" />
          <img
            src={banner.image}
            alt={`${banner.title} 推荐大图`}
            className="absolute inset-0 h-full w-full object-cover object-top"
            onError={(event) => {
              event.currentTarget.style.opacity = "0";
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/40 to-foreground-950/20" />
        </div>
      ))}

      <div className="relative z-10 mx-auto flex h-full max-w-screen2xl flex-col justify-end px-4 pb-14 md:px-6 md:pb-20">
        <div key={index} className="max-w-2xl animate-fade-up">
          <h1 className="text-xs font-bold uppercase tracking-widest text-primary-300 md:text-sm">
            网页游戏直接玩 · 热门网页游戏在线试玩平台
          </h1>
          <span className="mt-3 inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-background-50">
            <i className="ri-vip-crown-fill"></i>
            {banners[index].tag}
          </span>
          <h2 className="mt-4 text-3xl font-black leading-tight text-background-50 md:text-5xl">
            {banners[index].title}
          </h2>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-background-100 md:text-base">
            {banners[index].subtitle}
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <Link
              to={`/detail/${banners[index].gameId}`}
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-bold text-background-50 transition hover:bg-primary-600"
            >
              <i className="ri-play-circle-fill text-lg"></i>
              进入游戏详情
            </Link>
            <Link
              to="/search"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-5 py-3 text-sm font-medium text-background-50 backdrop-blur transition hover:bg-background-50/20"
            >
              <i className="ri-compass-3-line"></i>
              发现更多游戏
            </Link>
          </div>
        </div>

        <div className="mt-10 flex items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            {banners.map((banner, bannerIndex) => (
              <button
                key={banner.gameId}
                type="button"
                aria-label={`切换到 ${banner.title}`}
                onClick={() => setIndex(bannerIndex)}
                className={`h-2 rounded-full transition-all duration-300 ${
                  bannerIndex === index ? "w-8 bg-primary-500" : "w-2 bg-background-50/50 hover:bg-background-50/80"
                }`}
              />
            ))}
          </div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={goPrev}
              aria-label="上一张"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-background-50/30 bg-background-50/10 text-background-50 backdrop-blur transition hover:bg-primary-500"
            >
              <i className="ri-arrow-left-s-line text-xl"></i>
            </button>
            <button
              type="button"
              onClick={goNext}
              aria-label="下一张"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-background-50/30 bg-background-50/10 text-background-50 backdrop-blur transition hover:bg-primary-500"
            >
              <i className="ri-arrow-right-s-line text-xl"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}